/*
========================================
LOAD DEALER DATA
========================================
*/

window.DEALERS = [];

const dealerData = document.getElementById("dealer-data");

if (dealerData) {

    try {

        window.DEALERS = JSON.parse(
            dealerData.textContent
        );

        console.log(
            "Dealer Loaded:",
            window.DEALERS.length
        );

    } catch (e) {

        console.error(e);

    }

}

/* ======================================================
HELPERS
====================================================== */
function getUrl(link){
  if(!link) return null;
  if(typeof link==="string") return link;
  if(link.url) return link.url;
  if(link.value) return link.value;
  return null;
}

function distance(lat1, lon1, lat2, lon2){
  const R = 6371;
  const dLat = (lat2-lat1)*Math.PI/180;
  const dLon = (lon2-lon1)*Math.PI/180;

  const a =
    Math.sin(dLat/2)**2 +
    Math.cos(lat1*Math.PI/180) *
    Math.cos(lat2*Math.PI/180) *
    Math.sin(dLon/2)**2;

  return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function isDesktop(){
  return !/Mobi|Android|iPhone/i.test(navigator.userAgent);
}


/* ======================================================
IP LOCATION (DESKTOP FALLBACK)
====================================================== */
function getLocationByIP(){
  return fetch("https://ipapi.co/json/")
    .then(res=>res.json())
    .then(data=>{
      if(!data.latitude || !data.longitude) return null;
      return {
        lat: data.latitude,
        lng: data.longitude
      };
    })
    .catch(()=>null);
}


/* ======================================================
MODAL
====================================================== */
document.body.insertAdjacentHTML("beforeend",`
<div id="dealerModal" class="dealer-modal">
  <div class="dealer-modal-box">
    <h3>Select the Nearest Dealer</h3>
    <div id="dealerList"></div>
    <button class="dealer-close">Close</button>
  </div>
</div>
`);

document.addEventListener("click",e=>{
  if(e.target.classList.contains("dealer-close")){
    document.getElementById("dealerModal").classList.remove("active");
  }
});


/* ======================================================
FALLBACK (SORT BY CITY)
====================================================== */
function fallback(){

  const modal = document.getElementById("dealerModal");
  const list  = document.getElementById("dealerList");

  let dealers = (window.DEALERS||[])
    .map(d=>({...d, dist:null}))
    .sort((a,b)=>(a.city||"").localeCompare(b.city||""));

  list.innerHTML = `
    <div style="margin-bottom:12px;color:#666;font-size:13px">
      Location unavailable / GPS inactive.<br>
      Shows dealers by city.
    </div>
  `;

  dealers.slice(0,5).forEach(d=>{
    const url = getUrl(d.buy_link);
    if(!url) return;

    const card = document.createElement("div");
    card.className = "dealer-card";

    card.innerHTML = `
      <strong>${d.name}</strong>
      <div>${d.city||"-"}</div>
      <div class="dealer-distance">Location unknown</div>
      <div class="dealer-btn">Buy at Dealer</div>
    `;

    card.onclick = ()=> window.location.href = url;

    list.appendChild(card);
  });

  modal.classList.add("active");
}


/* ======================================================
SHOW DEALERS
====================================================== */
function showDealerSelector(dealers, isApprox=false){

  const modal = document.getElementById("dealerModal");
  const list  = document.getElementById("dealerList");

  list.innerHTML = isApprox
    ? `<div style="margin-bottom:10px;font-size:13px;color:#666">
         Approximate location (desktop), results may not be accurate
       </div>`
    : "";

  dealers.forEach((d,i)=>{

    const url = getUrl(d.buy_link);
    if(!url) return;

    const badge = i===0
      ? `<div style="color:green;font-size:12px">Nearest Dealer</div>`
      : "";

    const card = document.createElement("div");
    card.className="dealer-card";

    card.innerHTML = `
      <strong>${d.name}</strong>
      <div>${d.city||""}</div>
      <div class="dealer-distance">
        ${d.dist ? d.dist.toFixed(1)+" km" : ""}
      </div>
      ${badge}
      <div class="dealer-btn">Buy at Dealer</div>
    `;

    card.onclick = ()=> window.location.href = url;

    list.appendChild(card);

  });

  modal.classList.add("active");
}


/* ======================================================
CORE PROCESS
====================================================== */
function processLocation(lat,lng,isApprox=false){

  const dealers = (window.DEALERS||[])
    .map(d=>{
      const dlat=parseFloat(d.lat);
      const dlng=parseFloat(d.lng);
      if(isNaN(dlat)||isNaN(dlng)) return null;

      return {...d, dist: distance(lat,lng,dlat,dlng)};
    })
    .filter(Boolean)
    .sort((a,b)=>a.dist-b.dist);

  const MAX_DISTANCE = isApprox ? 100 : 30;

  const nearby = dealers.filter(d=>d.dist<=MAX_DISTANCE);

  if(!nearby.length){
    fallback();
    return;
  }

  showDealerSelector(nearby.slice(0,4), isApprox);
}


/* ======================================================
MAIN ENGINE
====================================================== */
function smartDealerRedirect(){

  if(!navigator.geolocation){
    getLocationByIP().then(loc=>{
      loc ? processLocation(loc.lat,loc.lng,true) : fallback();
    });
    return;
  }

  navigator.geolocation.getCurrentPosition(

    pos=>{

      const acc = pos.coords.accuracy;

      /* mobile strict, desktop longgar */
      if(acc > 10000 && !isDesktop()){
        fallback();
        return;
      }

      processLocation(
        pos.coords.latitude,
        pos.coords.longitude,
        isDesktop()
      );

    },

    err=>{

      console.warn("GPS error:", err.message);

      getLocationByIP().then(loc=>{
        loc ? processLocation(loc.lat,loc.lng,true) : fallback();
      });

    },

    {
      enableHighAccuracy:true,
      timeout:7000,
      maximumAge:0
    }

  );
}


/* ======================================================
INTERCEPT BUTTON
====================================================== */
document.addEventListener("click",function(e){

  const form = e.target.closest('form[action*="/cart/add"]');
  const buyNow = e.target.closest("shopify-buy-it-now-button button");

  if(form || buyNow){
    e.preventDefault();
    e.stopImmediatePropagation();
    smartDealerRedirect();
  }

}, true);
